<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <v-form
      ref="form"
      @keyup.enter="resetPassword"
      @submit.prevent
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('title.reset_password') }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-5 pb-0">
          <validation-observer ref="observer">
            <v-row class="pa-md-5 pa-2 pt-0">
              <v-col
                cols="12"
                class="pt-0"
              >
                <p class="pa-0 ma-0">
                  {{ $t('label.email_reset_instructions') }}
                </p>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:254|email"
                >
                  <v-text-field
                    v-model="email"
                    :label="$t('label.email')"
                    :error-messages="errors"
                    name="login"
                    prepend-icon="mdi-account"
                    type="email"
                    @keyup.enter="resetPassword"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </validation-observer>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success"
            @click="resetPassword"
          >
            {{ $t('button.continue') }}
          </v-btn>
          <v-btn
            color="error"
            text
            @click="cancel"
          >
            {{ $t('button.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import DialogClosable from '@/mixins/dialog-closable';
import { performAction } from '@/services/vue-utils';
import toast from '@/plugins/toast-plugin/toast';

export default Vue.extend({
  name: 'ResetPasswordDialog',
  mixins: [DialogClosable],
  data() {
    return {
      email: '',
      dialog: false,
    };
  },
  computed: {

  },
  watch: {
    dialog(value, oldValue) {

    },
  },
  methods: {
    reset() {
      (this.$refs.form as Vue & { reset: () => void }).reset();
      (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
    },
    cancel() {
      this.reset();
      this.dialog = false;
    },
    async resetPassword() {
      const isValid = await (this.$refs.observer as InstanceType<typeof ValidationObserver>).validate();
      if (!isValid) {
        toast.error(this.$i18n.tc('error.validation_failed'));
        return;
      }

      const ok = await performAction(
        this.$i18n.tc('message.success_new_password_sent'),
        this.$i18n.tc('error.changing_password'),
        async () => this.$tstore.dispatch('resetPassword', { username: this.email }),
      );

      if (ok) {
        this.reset();
        this.dialog = false;
      }
    },
  },
});
</script>
